module.exports = __webpack_public_path__ + "static/media/Sort - Small.c021f063.svg";